export default {
      id: "mindmotion-logo-usage",
      viewBox: "0 0 224 34",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#mindmotion-logo",
      toString: function () {
        return this.url;
      }
    }